/* eslint-disable react/jsx-sort-props */

/**
 * DO NOT MODIFY THIS ICON DIRECTLY.
 *
 * THIS ICON WAS AUTOMATICALLY GENERATED.
 * SVG RETRIEVED FROM SPRING FOUNDATIONS FIGMA FILE.
 * @see https://www.figma.com/design/kcg95u086DD7Sa9or8Bwpq/%F0%9F%8C%B1--Foundations---Spring-2.0?node-id=24-2&p=f&t=75lUXy0FPOr0htKP-0
 */
import React from 'react';

import {Icon as BaseIcon, type BaseIconProps} from './Icon/Icon';
import {IconComponent} from './types';

export const CMSAddIcon = React.forwardRef<HTMLDivElement, BaseIconProps>(
  ({size = 16, ...props}, ref) => {
    return (
      <BaseIcon {...props} size={size} ref={ref}>
        <svg
          data-wf-icon="CMSAddIcon"
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g>
            <g>
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M8 2C6.68875 2 5.47691 2.2942 4.5752 2.79515C3.69042 3.2867 3 4.04561 3 5V11C3 11.9544 3.69042 12.7133 4.5752 13.2048C5.47691 13.7058 6.68875 14 8 14V13C6.82597 13 5.7878 12.7346 5.06084 12.3307C4.31694 11.9174 4 11.4263 4 11V9.82287C4.17733 9.96383 4.37109 10.0915 4.5752 10.2048C5.47691 10.7058 6.68875 11 8 11V10C6.82597 10 5.7878 9.73456 5.06084 9.33069C4.31694 8.91741 4 8.42632 4 8V6.82287C4.17733 6.96383 4.37109 7.09145 4.5752 7.20485C5.47691 7.7058 6.68875 8 8 8C9.31125 8 10.5231 7.7058 11.4248 7.20485C11.6289 7.09145 11.8227 6.96383 12 6.82287V8H13V5C13 4.04561 12.3096 3.2867 11.4248 2.79515C10.5231 2.2942 9.31125 2 8 2ZM12 5C12 4.57368 11.6831 4.08259 10.9392 3.66931C10.2122 3.26544 9.17403 3 8 3C6.82597 3 5.7878 3.26544 5.06084 3.66931C4.31694 4.08259 4 4.57368 4 5C4 5.42632 4.31694 5.91741 5.06084 6.33069C5.7878 6.73456 6.82597 7 8 7C9.17403 7 10.2122 6.73456 10.9392 6.33069C11.6831 5.91741 12 5.42632 12 5Z"
                fill="currentColor"
              />
              <path
                d="M12 11V9H11V11H9V12H11V14H12V12H14V11H12Z"
                fill="currentColor"
              />
            </g>
          </g>
        </svg>
      </BaseIcon>
    );
  }
) as IconComponent;

CMSAddIcon.tags = [
  'collection',
  'coins',
  'stack',
  'add',
  'money',
  'increase',
  'deposit',
  'savings',
];

CMSAddIcon.category = 'General Icons';

CMSAddIcon.iconSize = 16;
